import { render, staticRenderFns } from "./EmailDeclined.vue?vue&type=template&id=32aa78ad&scoped=true&"
import script from "./EmailDeclined.vue?vue&type=script&lang=js&"
export * from "./EmailDeclined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa78ad",
  null
  
)

export default component.exports